module.exports = __webpack_public_path__ + "img/stu-pre-exam-return-btn.94e2e225.svg";